import React from 'react';
import s from './SectionHeader.module.css';

const SectionHeader = ({ title }) => {
  const sectionColor = title ? title.split(' ')[0] : '';

  return (
    <div className={s.sectionHeader}>
      <div className={s.sectionHeaderContent}>
        <h2 className={`${s.noMargin} ${sectionColor}`}>{title}</h2>
      </div>
      <div className={s.hr} />
    </div>
  );
};

export default SectionHeader;
